import { render, staticRenderFns } from "./public-add-quiz.html?vue&type=template&id=6a13930f&scoped=true&"
import script from "./public-add-quiz.js?vue&type=script&lang=js&"
export * from "./public-add-quiz.js?vue&type=script&lang=js&"
import style0 from "./public-add-quiz.scss?vue&type=style&index=0&id=6a13930f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13930f",
  null
  
)

export default component.exports